import { SimInfo } from '../model';

import { SimMapper } from './sim.mapper';

export class SimInfoMapper {
  public static map(data: any): SimInfo {
    return new SimInfo(data.imei, data.index, SimMapper.map(data.sim));
  }
}
